import { HStack, Pressable } from "@gluestack-ui/themed";
import { Icon } from "@repo/core/components/core/Icon";
import { Text } from "@repo/core/components/core/Text";

import { ISectionTitleProps } from "./types";

export const SectionTitle = ({ title, onShowAll }: ISectionTitleProps) => {
  return (
    <HStack alignItems="center" gap="$1">
      <Text fontSize="$lg" color="$textLight800" fontWeight={700} flex={1}>
        {title}
      </Text>
      {onShowAll ? (
        <Pressable onPress={onShowAll}>
          <HStack alignItems="center" gap="$1">
            <Text color="$primary700" pb="$0.5" fontSize="$md" fontWeight={600}>
              Ver todas
            </Text>
            <Icon name="chevron-right" size={16} color="$primary700" />
          </HStack>
        </Pressable>
      ) : null}
    </HStack>
  );
};
